import { z } from 'zod';
import { RoleSchema, UserSchema } from './users';

// Mensajes en español explícitos: sin ellos Zod emite sus textos por defecto en
// inglés ("Invalid email", "String must contain at least 1 character(s)") y se
// muestran tal cual bajo los campos del login y en los errores 400 de la API.
export const LoginRequestSchema = z.object({
  correo: z
    .string({ required_error: 'El correo es obligatorio' })
    .min(1, 'El correo es obligatorio')
    .email('Ingresa un correo electrónico válido')
    .max(254, 'El correo es demasiado largo'),
  password: z
    .string({ required_error: 'La contraseña es obligatoria' })
    .min(1, 'La contraseña es obligatoria')
    .max(128, 'La contraseña no puede superar los 128 caracteres'),
  remember: z.boolean().default(false),
});
export type LoginRequest = z.infer<typeof LoginRequestSchema>;

/**
 * El backend NUNCA devuelve el token en el cuerpo: lo deposita en cookie httpOnly.
 * Esta respuesta solo expone metadatos seguros para que el frontend hidrate la UI.
 */
export const SessionUserSchema = UserSchema.pick({
  id: true,
  nombre: true,
  correo: true,
  rol: true,
  especialidad: true,
  registroProfesional: true,
  firmaUrl: true,
}).extend({
  permisos: z.array(z.string()),
  expiraEn: z.string().datetime(),
  /** Si es `true`, el usuario debe cambiar su contraseña temporal. */
  mustChangePassword: z.boolean().default(false),
  /** `true` = súper administrador (cuenta protegida). El front usa esto para
   * ocultar la edición/reseteo de contraseña de súper admins a un admin normal. */
  esSuperAdmin: z.boolean().default(false),
});
export type SessionUser = z.infer<typeof SessionUserSchema>;

export const LoginResponseSchema = z.object({
  user: SessionUserSchema,
});
export type LoginResponse = z.infer<typeof LoginResponseSchema>;

export const ChangePasswordSchema = z
  .object({
    actual: z.string().min(1).max(128),
    nueva: z.string().min(12).max(128),
    confirmacion: z.string().min(12).max(128),
  })
  .refine((d) => d.nueva === d.confirmacion, {
    message: 'La confirmación no coincide',
    path: ['confirmacion'],
  });
export type ChangePasswordInput = z.infer<typeof ChangePasswordSchema>;

export { RoleSchema };
